import { PaginationProps } from './type';

export const tablePaginationDefaultProps: PaginationProps = {
  defaultCurrent: 1,
  defaultPageSize: 10,
  total: 0,
};
